import React, { useState } from "react";
import "./TradingOrder.css";

const TradingOrder = () => {
  const [orderType, setOrderType] = useState("BUY");
  const [exchange, setExchange] = useState("BSE");
  const [tradeType, setTradeType] = useState("INTRADAY");
  const [orderMode, setOrderMode] = useState("Regular");
  const [quantity, setQuantity] = useState(1);
  const [priceType, setPriceType] = useState("Market");
  const [stopLoss, setStopLoss] = useState(false);
  const [triggerPrice, setTriggerPrice] = useState(1);
  const [validity, setValidity] = useState("Day");
  const [disclosedQty, setDisclosedQty] = useState(false);

  // Sample stock data
  const stockData = {
    symbol: "TCS",
    name: "Tata Consultancy Services",
    logo: "tcs", // Will use text logo
    nsePrice: 3235.70,
    nseChange: 0.86,
    bsePrice: 3235.70,
    bseChange: 0.86,
    availableMargin: 0.00,
    requiredMargin: 808.92,
  };

  // Market depth data
  const marketDepth = [
    { buyOrders: 1, buyQty: 240, bid: 3259.10, offer: 3259.10, sellQty: 195, sellOrders: 2 },
    { buyOrders: 1, buyQty: 8, bid: 3259.10, offer: 3259.10, sellQty: 195, sellOrders: 2 },
    { buyOrders: 1, buyQty: 19, bid: 3259.10, offer: 3259.10, sellQty: 195, sellOrders: 2 },
    { buyOrders: 1, buyQty: 18, bid: 3259.10, offer: 3259.10, sellQty: 195, sellOrders: 2 },
  ];

  const handleQuantityChange = (delta) => {
    setQuantity((prev) => Math.max(1, prev + delta));
  };

  const handleTriggerPriceChange = (delta) => {
    setTriggerPrice((prev) => Math.max(1, prev + delta));
  };

  const handleBuyNow = () => {
    console.log("Placing order:", {
      orderType,
      tradeType,
      orderMode,
      quantity,
      priceType,
      stopLoss,
      triggerPrice: stopLoss ? triggerPrice : null,
      validity,
      disclosedQty,
    });
  };

  return (
    <div className="trading-wrapper">
      <div className="trading-container">
        {/* Stock Header */}
        <div className="trading-header">
          <div className="stock-info">
            <div className="stock-logo">
              <span className="logo-text">tcs</span>
            </div>
            <div className="stock-details">
              <span className="stock-symbol">{stockData.symbol}</span>
              <span className="stock-name">{stockData.name}</span>
            </div>
          </div>
          <div className="order-type-toggle">
            <button
              className={`order-btn buy-btn ${orderType === "BUY" ? "active" : ""}`}
              onClick={() => setOrderType("BUY")}
            >
              BUY
            </button>
            <button
              className={`order-btn sell-btn ${orderType === "SELL" ? "active" : ""}`}
              onClick={() => setOrderType("SELL")}
            >
              SELL
            </button>
          </div>
        </div>

        {/* Price Section */}
        <div className="price-section">
          <div
            className={`exchange-price ${exchange === "NSE" ? "active" : ""}`}
            onClick={() => setExchange("NSE")}
          >
            <span className="exchange-label">NSE</span>
            <span className="price-value">₹{stockData.nsePrice.toFixed(2)}</span>
            <span className="price-change positive">↗ (+{stockData.nseChange}%)</span>
          </div>
          <div
            className={`exchange-price ${exchange === "BSE" ? "active" : ""}`}
            onClick={() => setExchange("BSE")}
          >
            <span className="exchange-label">BSE</span>
            <span className="price-value">₹{stockData.bsePrice.toFixed(2)}</span>
            <span className="price-change positive">↗ (+{stockData.bseChange}%)</span>
          </div>
        </div>

        {/* Trade Type Toggle */}
        <div className="trade-type-section">
          <div className="trade-type-toggle">
            <button
              className={`trade-btn ${tradeType === "INTRADAY" ? "active" : ""}`}
              onClick={() => setTradeType("INTRADAY")}
            >
              INTRADAY
            </button>
            <button
              className={`trade-btn ${tradeType === "DELIVERY" ? "active" : ""}`}
              onClick={() => setTradeType("DELIVERY")}
            >
              DELIVERY
            </button>
          </div>
        </div>

        {/* Order Mode Toggle */}
        <div className="order-mode-section">
          <button
            className={`mode-btn ${orderMode === "Regular" ? "active" : ""}`}
            onClick={() => setOrderMode("Regular")}
          >
            Regular
          </button>
          <button
            className={`mode-btn ${orderMode === "Cover" ? "active" : ""}`}
            onClick={() => setOrderMode("Cover")}
          >
            Cover
          </button>
        </div>

        {/* Form Section */}
        <div className="trading-form">
          {/* Quantity */}
          <div className="form-row">
            <label className="form-label">Quantity</label>
            <div className="quantity-control">
              <button className="qty-btn" onClick={() => handleQuantityChange(-1)}>-</button>
              <input
                type="number"
                className="qty-input"
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
              />
              <button className="qty-btn" onClick={() => handleQuantityChange(1)}>+</button>
            </div>
          </div>

          {/* Order Type */}
          <div className="form-row">
            <label className="form-label">Order Type</label>
            <div className="price-type-toggle">
              <button
                className={`price-btn ${priceType === "Market" ? "active" : ""}`}
                onClick={() => setPriceType("Market")}
              >
                Market
              </button>
              <button
                className={`price-btn ${priceType === "Limit" ? "active" : ""}`}
                onClick={() => setPriceType("Limit")}
              >
                Limit
              </button>
            </div>
          </div>

          {/* Stop Loss */}
          <div className="form-row">
            <label className="form-label">Stop Loss</label>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={stopLoss}
                onChange={(e) => setStopLoss(e.target.checked)}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          {/* Trigger Price - Show when Stop Loss is enabled */}
          {stopLoss && (
            <div className="form-row trigger-row">
              <label className="form-label">Trigger Price:</label>
              <div className="quantity-control">
                <button className="qty-btn" onClick={() => handleTriggerPriceChange(-1)}>-</button>
                <input
                  type="number"
                  className="qty-input"
                  value={triggerPrice}
                  onChange={(e) => setTriggerPrice(Math.max(1, parseInt(e.target.value) || 1))}
                />
                <button className="qty-btn" onClick={() => handleTriggerPriceChange(1)}>+</button>
              </div>
            </div>
          )}

          {/* Validity */}
          <div className="form-row">
            <label className="form-label">Validity</label>
            <div className="validity-toggle">
              <button
                className={`validity-btn ${validity === "Day" ? "active" : ""}`}
                onClick={() => setValidity("Day")}
              >
                Day
              </button>
              <button
                className={`validity-btn ${validity === "IOC" ? "active" : ""}`}
                onClick={() => setValidity("IOC")}
              >
                IOC
              </button>
            </div>
          </div>

          {/* Disclosed Quantity */}
          <div className="form-row">
            <label className="form-label">Disclosed Quantity</label>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={disclosedQty}
                onChange={(e) => setDisclosedQty(e.target.checked)}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>

        {/* Market Depth Section */}
        <div className="market-depth-section">
          <h3 className="section-title">Market Depth</h3>

          <div className="depth-table">
            <div className="depth-header">
              <span>Orders</span>
              <span>Qty</span>
              <span>Bid</span>
              <span>Offer</span>
              <span>Qty</span>
              <span>Orders</span>
            </div>
            {marketDepth.map((row, index) => (
              <div key={index} className="depth-row">
                <span className="buy-data">{row.buyOrders}</span>
                <span className="buy-data">{row.buyQty}</span>
                <span className="bid-price">{row.bid.toFixed(2)}</span>
                <span className="offer-price">{row.offer.toFixed(2)}</span>
                <span className="sell-data">{row.sellQty}</span>
                <span className="sell-data">{row.sellOrders}</span>
              </div>
            ))}
          </div>

          {/* Bid/Ask Bar */}
          <div className="bid-ask-section">
            <div className="bid-ask-labels">
              <span className="bid-label">Bid</span>
              <span className="ask-label">Ask</span>
            </div>
            <div className="bid-ask-bar">
              <div className="bid-bar" style={{ width: "78.95%" }}>
                <span>78.95%</span>
              </div>
              <div className="ask-bar" style={{ width: "22.05%" }}>
                <span>22.05%</span>
              </div>
            </div>
          </div>

          {/* TBQ/TSQ */}
          <div className="tbq-tsq-section">
            <div className="tbq-box">
              <span className="tbq-label">TBQ</span>
              <span className="tbq-value">20844590</span>
            </div>
            <div className="tsq-box">
              <span className="tsq-label">TSQ</span>
              <span className="tsq-value">20844590</span>
            </div>
          </div>
        </div>

        {/* Total Section */}
        <div className="total-section">
          <div className="total-header">
            <span className="total-label">Total</span>
            <span className="total-arrow">›</span>
          </div>
          <div className="margin-info">
            <div className="margin-item">
              <span className="margin-label">Available Margin</span>
              <span className="margin-value">₹{stockData.availableMargin.toFixed(2)}</span>
            </div>
            <div className="margin-item">
              <span className="margin-label">Required Margin</span>
              <span className="margin-value required">₹{stockData.requiredMargin.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* Buy Now Button */}
        <button
          className={`buy-now-btn ${orderType === "SELL" ? "sell" : ""}`}
          onClick={handleBuyNow}
        >
          {orderType === "BUY" ? "Buy Now" : "Sell Now"}
        </button>
      </div>
    </div>
  );
};

export default TradingOrder;
